import React, {useMemo} from "react";
import { css, Theme, useTheme } from "@emotion/react";

import RoundButton from "core/Components/Buttons/RoundButton";
import useBreakpoint from "core/hooks/useBreakpoint";
import {isDown, isUp} from "theme/breakpoints";

type Props = {
    data: ContentWithImage,
    isUsingAltDesign: boolean,
};

const Button: React.FC<Props> = ({ data, isUsingAltDesign }) => {
    const theme: Theme = useTheme();
    const { breakpoint } = useBreakpoint();

    const height = useMemo(() => {
        if (!isUsingAltDesign) return undefined;

        switch (true) {
            case isUp(breakpoint, '5xl'):
                return 70;
            case isDown(breakpoint, 'sm'):
                return 51;
            default:
                return 70;
        }
    }, [breakpoint]);

    const linkURL = data.innerURL || data.outerURL;

    const colourTheme = JSON.parse(data.theme);
    const { buttonTextColour, buttonColour, } = colourTheme;

    const buttonTextCustomStyle = css`
        font-size: 20px;

        ${isUsingAltDesign && css`
            font-family: ${theme.fonts.figtree};
            padding: 22px 45px;
            font-weight: ${theme.fonts.weights.medium};
        `};

        ${theme.breakpoints.up("5xl")} {
            font-size: 25px;
        }

        ${theme.breakpoints.down("sm")} {
            font-size: 16px;
            
            ${isUsingAltDesign && css`
                padding: 13px 22px;
            `};
        }
    `;

    const buttonContainerStyle = css`
        ${theme.breakpoints.down("sm")} {
            width: 100%
        }
    `;

    return (
        <RoundButton
            backgroundColour={data.buttonColour || buttonColour}
            textColour={data.buttonTextColour || buttonTextColour}
            buttonHoverColour={data.buttonHoverColour}
            textHoverColour={data.buttonTextHoverColour}
            linkURL={linkURL}
            css={buttonContainerStyle}
            buttonTextCustomStyle={buttonTextCustomStyle}
            buttonHeight={height}
            buttonBorderRadius={isUsingAltDesign ? 99 : undefined}
        >
            {data.buttonText}
        </RoundButton>

    );
}

export default Button;
